import React, { useState } from "react";
import { Row, Col, Card, CardBody, Input, Label, Spinner } from "reactstrap";
import { Tabs } from "antd";
import { useGetDigitalAgricultureBenchmarkByIdQuery } from "./RiskManagementApiSlice";
import DigitalAgricultureMap from "./DigitalAgricultureMap";
import marker from "./marker4.jpg";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";

const { TabPane } = Tabs;

const DigitalBenchmarkDetails = ({ benchmarkDetails }) => {
  const {
    data: getGtSurvey,
    isLoading,
  } = useGetDigitalAgricultureBenchmarkByIdQuery({
    pagination: { currentPage: 1, limit: 10, offset: 0 },
    SurveyNo: benchmarkDetails?.SurveyNo || "",
  });

  const GtPointSurvey = getGtSurvey?.data?.results || [];
  const [activeTab, setActiveTab] = useState("0");
  const [openLightbox, setOpenLightBox] = useState(false);
  const [lightBoxViewImage, setImageInLightbox] = useState("");

  return (
    <div className="p-1">
      {isLoading ? (
        <div className="text-center">
          <Spinner size="large" />
        </div>
      ) : GtPointSurvey.length === 0 ? (
        <p className="text-center">No survey data available</p>
      ) : (
        <Tabs
          activeKey={activeTab}
          onChange={(key) => setActiveTab(key)}
          type="card"
        >
          {GtPointSurvey.map((survey, index) => (
            <TabPane tab={`Benchmark ${index + 1}`} key={String(index)}>
              <h5 className="mb-3 text-secondary">
                Benchmark {index + 1} Details
              </h5>
              <h6 className="mt-3 mb-3 text-primary">Basic Details</h6>
              <Row className="mb-3">
                <Col lg="3">
                  <Label>Benchmark No</Label>
                  <Input value={survey?.SubSurveyNo || "-"} disabled />
                </Col>
                <Col lg="3">
                  <Label>Created By</Label>
                  <Input value={survey?.CreatedName || "-"} disabled />
                </Col>
                <Col lg="3">
                  <Label>Phone No</Label>
                  <Input value={survey?.CreatedMobile || "-"} disabled />
                </Col>
                <Col lg="3">
                  <Label>Created Date</Label>
                  <Input
                    value={survey?.CreatedOn?.slice(0, 10) || "-"}
                    disabled
                  />
                </Col>
              </Row>

              <h6 className="mt-3 mb-3 text-primary">Crop Details</h6>
              <Row className="mb-3">
                <Col lg="3">
                  <Label>Crop Name</Label>
                  <Input value={survey?.CropName || "-"} disabled />
                </Col>
                <Col lg="3">
                  <Label>Crop Category</Label>
                  <Input value={survey?.CropCategoryName || "-"} disabled />
                </Col>
                <Col lg="3">
                  <Label>Cropping Type</Label>
                  <Input value={survey?.CroppingTypeName || "-"} disabled />
                </Col>
                <Col lg="3">
                  <Label>Season</Label>
                  <Input value={survey?.Season || "-"} disabled />
                </Col>
              </Row>

              <h6 className="mt-3 mb-3 text-primary">Sowing & Harvesting</h6>
              <Row className="mb-3">
                <Col lg="3">
                  <Label>Sowing Date</Label>
                  <Input value={survey?.SowingDate || "-"} disabled />
                </Col>
                <Col lg="3">
                  <Label>Harvest Date</Label>
                  <Input value={survey?.HarvestDate || "-"} disabled />
                </Col>
                <Col lg="3">
                  <Label>Showing Method</Label>
                  <Input value={survey?.ShowingMethodName || "-"} disabled />
                </Col>
              </Row>

              <h6 className="mt-3 mb-3 text-primary">Soil & Irrigation</h6>
              <Row className="mb-3">
                <Col lg="3">
                  <Label>Soil Condition</Label>
                  <Input value={survey?.SoilConditionName || "-"} disabled />
                </Col>
                <Col lg="3">
                  <Label>Source Of Irrigation</Label>
                  <Input
                    value={survey?.SourceOfIrrigationName || "-"}
                    disabled
                  />
                </Col>
                <Col lg="3">
                  <Label>Ratio Of Major Crop</Label>
                  <Input value={survey?.RatioOfMajorCrop || "-"} disabled />
                </Col>
              </Row>

              <h6 className="mt-3 mb-3 text-primary">
                Previous & Minor Crops
              </h6>
              <Row className="mb-3">
                <Col lg="3">
                  <Label>Previous Crop</Label>
                  <Input value={survey?.PreviousCropName || "-"} disabled />
                </Col>
                <Col lg="3">
                  <Label>Previous Crop Type</Label>
                  <Input
                    value={survey?.PreviousCropTypeName || "-"}
                    disabled
                  />
                </Col>
                <Col lg="3">
                  <Label>Minor Crop</Label>
                  <Input value={survey?.MinorCropName || "-"} disabled />
                </Col>
                <Col lg="3">
                  <Label>Minor Crop Category</Label>
                  <Input
                    value={survey?.MinorCropCategoryName || "-"}
                    disabled
                  />
                </Col>
              </Row>

              <h6 className="mt-3 mb-3 text-primary">Location</h6>
              <Row className="mb-3">
                <Col lg="3">
                  <Label>State</Label>
                  <Input value={survey?.StateName || "-"} disabled />
                </Col>
                <Col lg="3">
                  <Label>District</Label>
                  <Input value={survey?.DistrictName || "-"} disabled />
                </Col>
                <Col lg="3">
                  <Label>Block</Label>
                  <Input value={survey?.BlockName || "-"} disabled />
                </Col>
                <Col lg="3">
                  <Label>Village</Label>
                  <Input value={survey?.VillageName || "-"} disabled />
                </Col>
              </Row>

              <h6 className="mt-4 mb-3 text-primary">Documents</h6>
              <Row>
                {survey?.Media && survey.Media.length > 0 ? (
                  survey.Media.map(
                    (doc, i) =>
                      doc?.ImagePath !== "" && (
                        <Col lg={3} key={i} className="mb-2">
                          <Card className="text-center border shadow-sm">
                            <CardBody className="p-2">
                              <p className="text-uppercase">{doc.Attribute}</p>
                              <hr />
                              {doc.ImagePath.includes("mp4") ? (
                                <video width="100%" height="180" controls>
                                  <source
                                    src={doc.ImagePath}
                                    type="video/mp4"
                                  />
                                </video>
                              ) : doc.ImagePath.includes("pdf") ? (
                                <object
                                  data={doc.ImagePath}
                                  type="application/pdf"
                                  width="100%"
                                  height="200px"
                                />
                              ) : (
                                <img
                                  src={doc.ImagePath}
                                  alt=""
                                  className="img-fluid cursor-pointer"
                                  style={{
                                    maxHeight: "180px",
                                    objectFit: "cover",
                                  }}
                                  onClick={() => {
                                    setOpenLightBox(true);
                                    setImageInLightbox(doc.ImagePath);
                                  }}
                                />
                              )}
                              {openLightbox ? (
                                <Lightbox
                                  image={lightBoxViewImage}
                                  title="Image Title"
                                  onClose={() => setOpenLightBox(false)}
                                />
                              ) : null}
                            </CardBody>
                          </Card>
                        </Col>
                      )
                  )
                ) : (
                  <p className="text-muted ps-3">No media available</p>
                )}
              </Row>

              <div className="d-flex justify-content-between align-items-center mt-4 mb-3">
                <h6 className="text-primary mb-0">Geo Tag Map</h6>

                <div className="d-flex gap-3 mt-2">
                  <div
                    className="d-flex align-items-center gap-1 px-2 py-1 border rounded-pill"
                    style={{
                      background: "#f8f9fa",
                      fontSize: "0.85rem",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src="https://images.ctfassets.net/3prze68gbwl1/assetglossary-17su9wok1ui0z7w/c4c4bdcdf0d0f86447d3efc450d1d081/map-marker.png"
                      height="15"
                      width="15"
                      alt="Survey Icon"
                    />
                    <span>Benchmark</span>
                  </div>

                  <div
                    className="d-flex align-items-center gap-1 px-2 py-1 border rounded-pill"
                    style={{
                      background: "#f8f9fa",
                      fontSize: "0.85rem",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src={marker}
                      height="15"
                      width="10"
                      alt="Benchmark Icon"
                    />
                    <span>Revisit</span>
                  </div>
                </div>
              </div>
              <DigitalAgricultureMap
                listData={survey}
                otherMedia={survey?.Media}
                benchmarkDetails={benchmarkDetails}
              />
            </TabPane>
          ))}
        </Tabs>
      )}
    </div>
  );
};

export default DigitalBenchmarkDetails;
